import React, { useState } from 'react';
import siteFacts from '../../content/siteFacts.json';
import { Eyebrow, focusRing } from './shared';

/**
 * Plain-language answers to the questions people (and AI assistants) ask about Apnaaapan.
 * The same Q&As are sent as FAQPage structured data by the server (lib/prerender.js),
 * so keep the visible text and src/content/siteFacts.json in sync by editing only the JSON.
 */
export default function HomeFaq() {
  const [open, setOpen] = useState(0);
  const faqs = siteFacts.faqs;

  return (
    <section aria-labelledby="home-faq-title" className="bg-apn-bg py-14 sm:py-20 short:py-10">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8">
        <div>
          <Eyebrow>Quick answers</Eyebrow>
          <h2 id="home-faq-title" data-animate="split-heading" className="mt-3 font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.03em] text-apn-ink sm:text-5xl">
            Things people ask us first
          </h2>
          <p className="mt-4 max-w-md text-lg text-apn-text">Still curious? WhatsApp us and a real person from the studio will reply.</p>
        </div>

        <ul data-animate="stagger" className="divide-y divide-apn-line border-y border-apn-line">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            const id = `home-faq-${i}`;
            return (
              <li key={item.q}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={`${id}-answer`}
                    id={`${id}-question`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className={`flex min-h-[60px] w-full items-center justify-between gap-4 py-4 text-left font-display text-xl font-semibold text-apn-ink sm:text-2xl ${focusRing}`}
                  >
                    {item.q}
                    <span
                      aria-hidden="true"
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-apn-line text-apn-ink transition-transform duration-300 motion-reduce:transition-none ${isOpen ? 'rotate-45 bg-apn-orange text-white' : ''}`}
                    >
                      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                    </span>
                  </button>
                </h3>
                {/* Answers stay in the DOM (hidden attribute) so the text is always crawlable */}
                <div id={`${id}-answer`} role="region" aria-labelledby={`${id}-question`} hidden={!isOpen} className="pb-5 pr-12">
                  <p className="text-base leading-relaxed text-apn-text sm:text-lg">{item.a}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
